/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import ChangerTrackerNavigateOptions from "./ChangeTrackerNavigateOptions";
import IAppContextChangeTracker from "./IAppContextChangeTracker";
import IChangeTracker from "./IChangeTracker";

const changeTrackers: Map<string, IChangeTracker> = new Map();

export default class AppContextChangeTracker implements IAppContextChangeTracker {
    public get hasAnyChanges(): boolean {
        for (const changeTracker of Array.from(changeTrackers.values())) {
            if (changeTracker.hasAnyChanges()) {
                return true;
            }
        }

        return false;
    }

    public register(changeTracker: IChangeTracker) {
        changeTrackers.set(changeTracker.id, changeTracker);
        return () => {
            changeTrackers.delete(changeTracker.id);
        };
    }

    public async speichere(navigateOptions: ChangerTrackerNavigateOptions): Promise<void> {
        const promises: Promise<void>[] = []
        changeTrackers.forEach(changeTracker =>
            promises.push(changeTracker.speichere(navigateOptions)));
        await Promise.all(promises);
    }

    public clearAll() {
        changeTrackers.clear();
    }
}
